import { render } from "./common-content-wrapper.vue?vue&type=template&id=0e226796&ts=true"
import script from "./common-content-wrapper.vue?vue&type=script&lang=ts"
export * from "./common-content-wrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__